import lang from '../../lib/language';

import helpCenterLogo from '../../assets/img/icon-help.png';
import logoutLogo from '../../assets/img/icon-logout.png';
import tradesLogo from '../../assets/img/icon-orders-trades.png';
import payoutsLogo from '../../assets/img/icon-payouts.png';
import personalDetailsLogo from '../../assets/img/icon-personal-details.png';
import securityLogo from '../../assets/img/icon-security.png';
import LinearSwitchIcon from '../../assets/img/switch.png';
import { UI_ROUTES } from '../../util/routes';

import { myProfileIds } from './MyProfile.constants';
import { MyProfileItem } from './MyProfile.types';

export const getMenuList = (
  hasPaidAndDemoPlan?: boolean,
  message?: string,
  isReferralsEnabled?: boolean,
): MyProfileItem[] => {
  const menuList: MyProfileItem[] = [];
  if (hasPaidAndDemoPlan && message) {
    menuList.push({
      id: myProfileIds.changePlan,
      label: message,
      path: '',
      img: LinearSwitchIcon,
    });
  }

  menuList.push({
    id: myProfileIds.personalDetails,
    label: lang.myProfilePersonalDetails(),
    path: UI_ROUTES.myAccountPersonalDetails,
    img: personalDetailsLogo,
  });

  if (isReferralsEnabled) {
    menuList.push({
      id: myProfileIds.payouts,
      label: lang.commonPayoutsTitle(),
      path: UI_ROUTES.payouts,
      img: payoutsLogo,
    });
  }

  menuList.push({
    id: myProfileIds.tradingHistory,
    label: lang.commonTradeHistoryTitle(),
    path: UI_ROUTES.tradeHistory,
    img: tradesLogo,
  });

  menuList.push({
    id: myProfileIds.security,
    label: lang.mobileProfileChangePassword(),
    img: securityLogo,
  });

  menuList.push({
    id: myProfileIds.helpCenter,
    label: lang.myProfileHelpCenter(),
    path: '',
    img: helpCenterLogo,
  });

  menuList.push({
    id: myProfileIds.logout,
    label: lang.myProfileLogout(),
    path: '',
    img: logoutLogo,
  });

  return menuList;
};
